import React from 'react';
import { FiGithub, FiPackage, FiExternalLink } from 'react-icons/fi';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-400 pt-16 pb-8 px-4">
      <div className="max-w-6xl mx-auto">
        <div className="footer-grid grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Column 1: Logo & Description */}
          <div>
            <h3 className="text-2xl font-heading font-bold gradient-text mb-4">
              sl-address
            </h3>
            <p className="font-body leading-relaxed">
              Complete Sri Lankan postal code utilities
            </p>
          </div>

          {/* Column 2: Links */}
          <div>
            <h4 className="text-white font-heading font-semibold mb-4">
              Links
            </h4>
            <ul className="space-y-3">
              <li>
                <a
                  href="https://github.com/sumudu-k/sl-address"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 hover:text-white transition-colors"
                >
                  <FiGithub className="w-4 h-4" />
                  GitHub
                  <FiExternalLink className="w-3 h-3" />
                </a>
              </li>
              <li>
                <a
                  href="https://www.npmjs.com/package/sl-address"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 hover:text-white transition-colors"
                >
                  <FiPackage className="w-4 h-4" />
                  npm
                  <FiExternalLink className="w-3 h-3" />
                </a>
              </li>

            </ul>
          </div>

          {/* Column 3: Package Info */}
          <div>
            <h4 className="text-white font-heading font-semibold mb-4">
              Package
            </h4>
            <ul className="space-y-3 font-body">
              <li>
                <span className="text-gray-500">Version:</span>{' '}
                <span className="text-white">1.1.1</span>
              </li>
              <li>
                <span className="text-gray-500">License:</span>{' '}
                <span className="text-white">MIT</span>
              </li>
              <li>
                <span className="text-gray-500">Author:</span>{' '}
                <span className="text-white">Sumudu Kulathunga</span>
              </li>
              <li>
                <span className="text-gray-500">Contact:</span>{' '}
                <span className="text-white">lakshankulathunga21@gmail.com</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Visit counter */}
        <div className="flex justify-center mb-8">
          <img
            src="https://hits.sh/sumudu.site.svg?style=flat&label=Visitors&color=6366f1&labelColor=1e293b"
            alt="visitor count"
          />
        </div>
      </div>
    </footer>
  );
};

export default Footer;
